'use client';
import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import Link from 'next/link';
import { clsx } from 'clsx';
import { ButtonNew } from '@/components/ui/ButtonNew/ButtonNew';
import { OrderCallWrapper } from '@/components/features/OrderCallWrapper/OrderCallWrapper';
import { PhoneLink } from '@/components/ui/PhoneLink/PhoneLink';
import StatusOpen from '@/components/ui/StatusOpen/StatusOpen';
import MenuSvg from '@/assets/icons/menu.svg';
import CrossSvg from '@/assets/icons/x.svg';
import { headerMainMenu } from '@/constants/navMenu';
import { MedicalUnit, MedicalUnitScheduleRes } from '@/api/medicalUnits/medicalUnits.types';
import s from './BurgerMenu.module.scss';
import EyeSvg from '@/assets/icons/Eye.svg';

interface Props {
  schedule: MedicalUnitScheduleRes;
  aboutData: MedicalUnit;
  reason: string | null;
}

export const BurgerMenu = ({ aboutData, schedule, reason }: Props) => {
  const pathname = usePathname();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const closeDropdown = () => setIsOpen(false);
    document.addEventListener('click', closeDropdown);

    return () => document.removeEventListener('click', closeDropdown);
  }, [isOpen]);

  useEffect(() => {
    setIsOpen(false);
  }, [pathname]);

  return (
    <>
      <button className={s.burgerButton} onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? <CrossSvg /> : <MenuSvg />}
      </button>

      <div className={clsx(s.mobileMenu, { [s.mobileMenu_opened]: isOpen })}>
        <div className={'header-container'}>
          <div className={s.contactUs}>
            <div className={s.contactUs__title}>Свяжитесь с нами</div>
            <div>
              <PhoneLink className={s.contactUs__phone} phone={aboutData.main_phone} codeIsFour />
              <div className={s.contactUs__shedule}>
                {schedule.open_time
                  ? (
                    <div className={s.contactUs__statusWrapper}>
                      <span className={s.contactUs__shedule}>{schedule.open_time} - {schedule.close_time}{reason}</span>
                      <StatusOpen
                        openTime={schedule.open_time}
                        closeTime={schedule.close_time}
                      />
                    </div>
                  )
                  : (
                    <div>
                      выходной {reason}
                    </div>
                  )
                }
              </div>
            </div>

            <OrderCallWrapper className={s.contactUs__orderButton}>
              <ButtonNew text={'Записаться к нам'} />
            </OrderCallWrapper>
          </div>

          <button className={`${s.specialButton} bvi-open`}>
            <EyeSvg /> Режим для слабовидящих
          </button>

          <div className={s.menu}>
            <div className={s.menu__title}>Меню</div>
            <nav>
              <ul className={s.menu__list}>
                {headerMainMenu.map((item) => {
                  if (item.isHidden) return null;

                  return (
                    <li key={item.id} className={s.menu__item}>
                      <Link
                        scroll={false}
                        href={item.path}
                        className={s.menu__link}
                      >
                        {item.title}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
};